export const static_errors = {
	vital_parsing_error:
		"There was an error while reading the response to your request, please contact support.",
	unexpected_contact_support:
		"An unexpected error occurred. Please contact support if this occurs again.",
} as const;

export const ENV = { ...import.meta.env } as const;

export const TWO_FACTOR_AUTH_TIMED_OUT_ERROR_CODE = 10759;
export const USER_ALREADY_EXISTS_ERROR_CODE = 10348;
